function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import { SWRConfig } from 'swr';
import RootContext from './RootContext';
/**
 * @type ContextFetchRootPropsType
 * this interface defines the set of properties supported by the ContextFetchRoot React component
 */

/**
 * @component ContextFetchRoot
 * The <ContextFetchRoot> React component, which holds global configuration for all context fetches
 */

export function ContextFetchRoot(_ref) {
  var children = _ref.children,
      _ref$fetcher = _ref.fetcher,
      fetcher = _ref$fetcher === void 0 ? window.fetch : _ref$fetcher,
      swrConfigOverrides = _objectWithoutProperties(_ref, ["children", "fetcher"]);

  var swrConfig = _objectSpread({
    errorRetryCount: 5,
    errorRetryInterval: 500,
    revalidateOnFocus: false,
    suspense: false
  }, swrConfigOverrides);

  return /*#__PURE__*/React.createElement(SWRConfig, {
    value: swrConfig
  }, /*#__PURE__*/React.createElement(RootContext.Provider, {
    value: {
      fetcher: fetcher
    }
  }, children));
}
export default /*#__PURE__*/memo(ContextFetchRoot);